import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import JoinUs from "./pages/JoinUs";
import OurServices from "./pages/OurServices";
import Insights from "./pages/Insights";
import Pricing from "./pages/Pricing";
import AdvertisingAndMedia from "./pages/AdvertisingAndMedia";
import BusinessSolutions from "./pages/BusinessSolutions";
import AboutUs from "./pages/AboutUs";
import Software from "./routes/PricingRoutes/Software";
import Marketing from "./routes/PricingRoutes/Marketing";
import Creative from "./routes/PricingRoutes/Creative";
import SoftwareSolutions from "./pages/SoftwareSolutions";
import CreativeDesign from "./pages/CreativeDesign";
import Terms from "./routes/terms";
import Legal from "./routes/legal";
import Privacy from "./routes/privacy";
import "./App.css";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to={`/en/`} replace />} />
          <Route path="/:lang">
            <Route index element={<Home />} />
            <Route path="ContactUs" element={<ContactUs />} />
            <Route path="JoinUs" element={<JoinUs />} />
            <Route path="OurServices" element={<OurServices />} />
            <Route path="Insights" element={<Insights />} />
            <Route
              path="AdvertisingAndMedia"
              element={<AdvertisingAndMedia />}
            />
            <Route path="BusinessSolutions" element={<BusinessSolutions />} />
            <Route path="SoftwareSolutions" element={<SoftwareSolutions />} />
            <Route path="AboutUs" element={<AboutUs />} />
            <Route path="CreativeDesign" element={<CreativeDesign />} />
            <Route path="Pricing">
              <Route index element={<Pricing />} />
              <Route path="Software" element={<Software />} />
              <Route path="Marketing" element={<Marketing />} />
              <Route path="Creative" element={<Creative />} />
            </Route>

            <Route path="TermsofUse" element={<Terms />} />
            <Route path="PrivacyPolicy" element={<Privacy />} />
            <Route path="Legal" element={<Legal />} />

            <Route path="*" element={<Navigate to={`/en/`} replace />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
